import * as React from "react";
import {cx} from "emotion";

import "./date-range-picker.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";
import {Dropdown} from "@Common/ui-components/dropdown/dropdown";

import {formatDate} from "../calendar-ui/format-date";

import {PickerPanel} from "./picker-ui/picker-panel";

export const DateRangePicker = ({
    startDate,
    endDate,
    minDate = {
        year: new Date().getFullYear() - 10,
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
    },
    maxDate = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
    },
}) => cs(
    ["focus", (_, next) => UseState({initValue: "hidden", next})],
    ["dropdown", ({focus}, next) => Dropdown({
        minExpandHeight: 480,
        renderToggle: next,
        renderExpand: ({position, close, domRef}) => PickerPanel({
            startDate, endDate,
            focus,
            minDate,
            maxDate,
            position,
            domRef,
            onClose: () => {
                close();
                focus.onChange("hidden");
            },
            onClear: () => {
                startDate.onChange(null);
                endDate.onChange(null);
                focus.onChange("start");
            },
        }),
    })],
    ({focus, dropdown: {showExpand, domRef}}) => (
        <div className="date-range-picker date-range-picker-f0e toggle" ref={domRef}>
            <button
                className={cx("start-date-button", {focused: focus.value==="start"})}
                onClick={() => {
                    showExpand(true);
                    focus.onChange("start");
                }}
                xd-qa-type="button"
                xd-qa-name="start-date"
            >
                {startDate.value ? (
                    formatDate(startDate.value)
                ) : (
                    "Start Date"
                )}
            </button>
            <div className="to">
                {startDate.value != null && endDate.value != null ? "to" : ""}
            </div>
            <button
                className={cx("end-date-button", {focused: focus.value==="end"})}
                onClick={() => {
                    showExpand(true);
                    focus.onChange("end");
                }}
                xd-qa-type="button"
                xd-qa-name="end-date"
            >
                {endDate.value ? (
                    formatDate(endDate.value)
                ) : (
                    "End Date"
                )}
            </button>

        </div>
    )
);
